module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA4BAMAAABEYRaeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURUdwTKioqKenp6qqqqioqKioqKenp6ioqBeLmTEAAAAHdFJOUwDfICF2rEBLUQVqAAAAsklEQVQ4y9WTsQ6DMAxEUQV7M2WF/kJ+gK17l3xC50jA/X4pQUkKPk9IUT1Ylp8u0p2cprmgWjNS5jEx1AEYqQxM+JUxod+YKGwBKnwDxhhgkZ9cOzALzO4MAsOV7PbYat3GXvqy+K1CdUQFG8DZU2FWYdhjRBoEW4K/CizGmIYYb58U5wovzhB6znBX2KSwIOSZgz37y0YrMOdcXB0GxV8V9vd5WsWfp2gW/nS+wY7f7gc9xJm2V0wyUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/contactInfo@3x.png
// module id = 1851
// module chunks = 0